import React from "react"

const FutureMealIcon = ({ style = {} }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      style={{
        flexShrink: 0,
        alignSelf: "flex-start",
        position: "relative",
        marginLeft: "auto",
        top: 3.5,
        ...style,
      }}
    >
      <g opacity="0.8">
        <path
          d="M10 2.07356C9.6737 2.02511 9.33978 2 9 2C5.27208 2 2.25 5.02208 2.25 8.75C2.25 12.4779 5.27208 15.5 9 15.5C12.3881 15.5 15.1932 13.0037 15.6764 9.75M12 2.70164C12.2792 2.84041 12.5475 2.99794 12.8031 3.17259M15.4488 6.75C15.5725 7.14937 15.6601 7.5646 15.7079 7.99188M14.118 4.34884C14.3519 4.62064 14.5646 4.91128 14.7534 5.21818"
          stroke="#69757D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 5.75V9.5H12"
          stroke="#69757D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default FutureMealIcon
